import Dropdown from "react-bootstrap/Dropdown";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import {WaypointModel} from "./WaypointModels";
import ConditionalRender from "../../../components/ConditionalRender";

const WaypointsSelectorDropdown = ({waypoints, name, onChange, selectedId, empty = false}) => {
    const [value, setValue] = useState({...WaypointModel});
    const styleButtonDrop = {width: "32.25px"};
    useEffect(() => {
        if (selectedId !== "" && selectedId !== null && waypoints.length) {
            let item;
            if (Number.isInteger(selectedId)) {
                item = waypoints.find((item) => item.id === selectedId);
            } else {
                item = waypoints.find((item) => item.id === selectedId.id);
            }
            setValue({...item});
        }
    }, [waypoints, selectedId]);

    const handleSelect = (key) => {
        if (key === "") {
            setValue({...WaypointModel});
            onChange(name, null);
            return;
        }
        let id = parseInt(key);
        let item = waypoints.find((item) => item.id === id);
        setValue({...item});
        onChange(name, item);
    };

    return (
        <Dropdown as={ButtonGroup} onSelect={handleSelect}>
            <Button variant="outline-secondary" style={{minWidth: "120px"}} disabled>
                {value.id ? (
                    <>
                        <FontAwesomeIcon icon={value.icon} /> {value.name}
                    </>
                ) : (
                    <>Seleccionar</>
                )}
            </Button>
            <Dropdown.Toggle split variant="outline-secondary" id="dynamicroute-destination" style={styleButtonDrop} />
            <Dropdown.Menu drop="down" align="end">
                <ConditionalRender condition={empty}>
                    <Dropdown.Item eventKey="">Ninguno</Dropdown.Item>
                </ConditionalRender>
                {waypoints.map((item, idx) => (
                    <Dropdown.Item eventKey={item.id} key={idx}>
                        <FontAwesomeIcon icon={item.icon} /> {item.name}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default WaypointsSelectorDropdown;
